<template>
  <div>
    <vm-table
        ref="vmTable"
        :filter.sync="filter"
        hide-show-hide-btn
        multi-selection
        url="esops/page">
      <template v-if="editAuth" #toolbar>
        <el-button v-if="editAuth" type="primary" @click="$refs.editPage.open()">新建</el-button>
      </template>
      <template #adSearch>
        <vm-search label="产线工序">
          <el-input v-model.trim="filter.productLineDesc" clearable placeholder="请输入"/>
        </vm-search>
        <vm-search label="文件名称" :value-width="200">
          <el-input v-model.trim="filter.fileName" clearable placeholder="请输入"/>
        </vm-search>
      </template>
      <el-table-column
          prop="fileName"
          label="文件名称"
          align="left"
          fixed="left"
          show-overflow-tooltip>
        <template v-slot="scope">
          <span style="color: #2d8cf0; cursor: pointer" @click="previewPage(scope.row)">
            {{scope.row.fileName}}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="fileSuffix" label="格式" align="center" width="60"/>
      <el-table-column prop="productLineDesc" label="产线工序" align="center" width="135"/>
      <el-table-column prop="pdfPageSize" label="页码" align="center" width="60"/>
      <el-table-column prop="note" label="备注" width="150" show-overflow-tooltip/>
      <el-table-column prop="createName" label="创建人" align="center" width="100"/>
      <el-table-column prop="createTime" label="创建时间" align="center" width="100"/>
      <el-table-column
          label="操作"
          align="center"
          fixed="right"
          width="260">
        <template v-slot="scope">
          <el-button v-if="editAuth" type="primary" @click="$refs.esopMaterial.open(scope.row)">物料绑定</el-button>
          <el-button v-if="editAuth" type="primary" @click="$refs.editPage.open(scope.row.id)">编辑</el-button>
          <el-button v-if="editAuth " type="danger" @click="handleDelete(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </vm-table>
    <esop-edit ref="editPage" @save-success="getList(-1)"/>
    <esop-material-list ref="esopMaterial" @save-success="getList(-1)"/>
    <esop-operation-record ref="operationRecord"/>
  </div>
</template>

<script>
  import VmTable from "@/components/v2/VmTable";
  import VmSearch from "@/components/v2/VmSearch";
  import VmSearchDate from "@/components/VmSearchDate.vue";
  import loginUtil from "@/util/loginUtil";
  import EsopEdit from "@/views/information/Esop/EsopEdit.vue";
  import EsopMaterialList from "@/views/information/Esop/EsopMaterialList.vue";
  import EsopOperationRecord from "@/views/information/Esop/EsopOperationRecord.vue";

  export default {
    name: "EsopList",
    components: {EsopOperationRecord, EsopMaterialList, EsopEdit, VmSearchDate, VmTable, VmSearch},
    data() {
      return {
        userId: loginUtil.getUserId(),
        delAuth: this.$auth(629),
        editAuth: this.$auth(629),
        bindingAuth: this.$auth(339),
        forceDeleteAuth: this.$auth(341),
        forceEditAuth: this.$auth(343),
        downLoadAuth: this.$auth(340),//同preview中下载
        downloadLoading: false,
        originDownloadLoading: false,
        filter: {
          fileType: "",
          fileName: "",
          createName: "",
          updateName: "",
          materialNo: "",
          needAudit: "",
          status: "",
          auditStatus: "",
          startDate: "",
          endDate: "",
          createDate: "",
          updateDate: "",
          updateDateStart: "",
          updateDateEnd: "",
        },
      };
    },
    mounted() {
      this.getList();
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      handleDelete(row) {
        this.$confirm(`确定删除文件 ${row.fileName} 吗?`, "提示", {type: "warning"}).then(() => {
          this.$http.delete("basic", "esops", row.id).then(() => {
            this.getList(-1);
            this.$message.success("删除成功");
          });
        });
      },
      previewPage(row) {
        this.$router.push({
          path: "/EsopPreview",
          query: {
            billId: row.id,
          },
        });
      },
      handleFileOpen() {
        if (this.$refs.vmTable.selection.length < 1) {
          this.$message.error("请至少选择一条记录");
          return;
        }
        let param = this.$refs.vmTable.selection.map(item => item.id);
        this.$confirm("确定启用所选文件吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .post("basic", "esops/enable", param)
            .then(() => {
              this.getList(-1);
              this.$message.success("操作成功");
            });
        });
      },
      handleFileDisable() {
        if (this.$refs.vmTable.selection.length < 1) {
          this.$message.error("请至少选择一条记录");
          return;
        }
        let param = this.$refs.vmTable.selection.map(item => item.id);
        this.$confirm("确定冻结所选文件吗?", "提示", {type: "warning"}).then(() => {
          this.$http
            .post("basic", "esops/freeze", param)
            .then(() => {
              this.getList(-1);
              this.$message.success("操作成功");
            });
        });
      },
      downloadBatch() {
        if (this.$refs.vmTable.selection.length < 1) {
          this.$message.error("请至少选择一条记录");
          return;
        }
        this.downloadLoading = true;
        let param = this.$refs.vmTable.selection.map(item => item.id);
        this.$http
          .postForFile("basic", "esops/download/batch/0", param)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
          }).finally(() => {
            this.downloadLoading = false;
          });
      },
      originDownloadBatch() {
        if (this.$refs.vmTable.selection.length < 1) {
          this.$message.error("请至少选择一条记录");
          return;
        }
        this.originDownloadLoading = true;
        let param = this.$refs.vmTable.selection.map(item => item.id);
        this.$http
          .postForFile("basic", "esops/download/batch/1", param)
          .then(res => {
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
          }).finally(() => {
            this.originDownloadLoading = false;
          });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
